import { Link } from '@mui/material';
import { styled } from '@mui/material/styles';

// Cast back to `typeof Link` because `styled()` collapses MUI's OverridableComponent typing, which
// is what carries the polymorphic `component` prop. Without it a link that acts on click rather
// than navigating (`component="button"`) doesn't type-check, and callers are pushed towards an
// anchor with no href — not focusable, not announced as a control. Runtime behaviour is unchanged.
const PeekLink = styled(Link)(({ theme }) => ({}));

export { PeekLink, PeekLink as default };
